import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import OzDrawerDraggable from '@@/library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from '@@/library/v4/components/OzDrawerStatic.vue'
import OzPopoverModal from '@@/library/v4/components/OzPopoverModal.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzScreenSizeAwarePopoverModal',
  props: {
    isPhone: { type: Boolean, default: false },
    isDraggableDrawer: { type: Boolean, default: false }
  },
  emits: ['scrim-click', 'scrim-esc', 'swipedown', 'swipeup', 'trigger-anchor-update'],
  setup(__props: any) {

/**
 * @file Screen size aware drawer modal that renders OzDrawer on phone and OzPopoverModal on desktop. Used in Content picker.
 */




return { __sfc: true,OzDrawerDraggable, OzDrawerStatic, OzPopoverModal }
}

})